import BranchOfficeResolvers from './branchOffices/queries'

export default {
  Query: {
    fields: {
      ...BranchOfficeResolvers
    }
  }
}
